export default __webpack_public_path__ + "static/media/k.8b3d5649.jpeg";